import { render, staticRenderFns } from "./ManageItem.vue?vue&type=template&id=55dd7b09&scoped=true&"
import script from "./ManageItem.vue?vue&type=script&lang=js&"
export * from "./ManageItem.vue?vue&type=script&lang=js&"
import style0 from "./ManageItem.vue?vue&type=style&index=0&id=55dd7b09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd7b09",
  null
  
)

export default component.exports